
export {Ellipsis,
Item,
Pagination,
ClayPaginationWithBasicItems} from '../../frontend-js-clay-web/__liferay__/exports/@clayui$pagination.js';
import __x__ from '../../frontend-js-clay-web/__liferay__/exports/@clayui$pagination.js';export default __x__;